import React from 'react';
import { Route, Outlet } from 'react-router-dom';
import Header from '../components/layout/header';
import Footer from '../components/layout/footer';

function PublicDarkLayout() {
  return (
    <>
      <div className="dark-header">
        <Header />
      </div>
      <Outlet />
      <Footer />
    </>
  );
}

export default PublicDarkLayout;
